export enum ActionTypes {
    DEPOSIT_MODAL_OPEN = "DEPOSIT_MODAL_OPEN",
    WITHDRAW_MODAL_OPEN = "WITHDRAW_MODAL_OPEN",
    INTEREST_MODAL_OPEN = "INTEREST_MODAL_OPEN",
    SET_SELECTED_VALUE = "SET_SELECTED_VALUE",

}
